const data = [
  {
    id: 1,
    name: "ABRAHAM JASON",
    description: "Every child has a right to a healthy meal. From lack of a school lunch program in the US.To scarcity of resources overseas, WE Cause helping to stand in the gap. Give Today!",
    image: "images/man2.png",
    title: "Developer",
    quoteRight: "images/right-solid.png",
  },
  {
    id: 2,
    name: "MELINA MILLER",
    description: "Missing after a landslide hit a camping site in Malaysia Peru has declared a 30-day state of emergency following violent protests over the president impeachment",
    image: "images/girl2.jpg",
    title: "Designer",
    quoteRight: "images/right-solid.png",
  },
  {
    id: 3,
    name: "TEENA JASON",
    description: "At least 19 people have died with dozens missing after a landslide hit a camping site in Malaysia Peru has declared a 30-day state of emergency following violent protests over",
    image: "images/girl1.jpg",
    title: "Doctor",
    quoteRight: "images/right-solid.png",
  },
  {
    id: 4,
    name: "ABRAHAM LINKON",
    description: "Child has a right to a healthy meal. From lack of a school lunch program in the US.To scarcity of resources overseas, WE Cause helping to stand in the gap. Give Today!",
    image: "images/man1.jpg",
    title: "Architecture",
    quoteRight: "images/right-solid.png",
  },
  {
    id: 5,
    name: "THOMAS MILLAR",
    description: "At least 19 people have died with dozens missing after a landslide hit a camping site in Malaysia Peru has declared a 30-day state.missing after a landslide hit",
    image: "images/man3.jpg",
    title: "Photographer",
    quoteRight: "images/right-solid.png",
  },
  {
    id: 6,
    name: "TEOFARIA GORES",
    description: "Camping site in Malaysia Peru has declared a 30-day state of emergency following violent protests over.To scarcity of resources overseas, WE Cause helping to stand in the gap.",
    image: "images/man4.jpg",
    title: "Developer",
    quoteRight: "images/right-solid.png",
  },
];
export default data;
